import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
} from "formik";
import NavLogo from "../../assets/images/favicon/primary-logo-400X116.svg";
import { loginWithEmailApi } from "../../api/authService";
import { withRouter } from "../../utils/withRouter";
import FullPageLoader from "../../common/FullPageLoader";

// import {
//   GoogleReCaptchaProvider,
//   useGoogleReCaptcha,
// } from "react-google-recaptcha-v3";

class Login extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    const token = localStorage.getItem("token");

    if (token) {
      this.props.navigate("/");
    }
  }

  validateForm = (values) => {
    const errors = {};

    if (!values.email) {
      errors.email = "Email is required";
    }

    if (!values.password) {
      errors.password = "Password is required";
    }

    return errors;
  };

  render() {
    const { loading } = this.state;

    return (
      <>
        {loading && (
          <FullPageLoader text="Signing in..." />
        )}

        <div className="auth np-login-page">
          <div className="auth_left">
            <div className="card np-login-card">

              {/* LOGO */}
              <div className="text-center mb-2">
                <Link
                  className="header-brand"
                  to="/"
                >
                  <img
                    src={NavLogo}
                    alt="Logo"
                    height="70"
                  />
                </Link>
              </div>

              <div className="card-body np-login-card__body">

                <div className="card-title">
                  Login to your account
                </div>

                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                    authError: "",
                  }}
                  validate={this.validateForm}
                  onSubmit={async (
                    values,
                    {
                      setSubmitting,
                      setFieldError,
                      setStatus,
                    }
                  ) => {
                    this.setState({
                      loading: true,
                    });

                    try {
                      setSubmitting(true);

                      // ==================================================
                      // RECAPTCHA
                      // ==================================================

                      // const executeRecaptcha =
                      //   this.props.executeRecaptcha;

                      // if (!executeRecaptcha) {
                      //   this.setState({
                      //     loading: false,
                      //   });

                      //   setSubmitting(false);

                      //   setFieldError(
                      //     "authError",
                      //     "Security verification is not ready. Please try again."
                      //   );

                      //   return;
                      // }

                      // const recaptchaToken =
                      //   await executeRecaptcha("login_form");

                      // ==================================================
                      // LOGIN API
                      // ==================================================

                      const response =
                        await loginWithEmailApi({
                          email: values.email,
                          password: values.password,
                          // recaptchaToken,
                        });

                      const data =
                        response?.data || {};

                      const token =
                        data?.token || null;

                      const user =
                        data?.user || null;

                      const permissions =
                        data?.permissions || {};

                      const menuComponents =
                        data?.menuComponents || [];

                      // ==================================================
                      // RESPONSE STATUS
                      // ==================================================

                      const responseStatus =
                        response?.status || 200;

                      // ==================================================
                      // SUCCESS CHECK
                      // ==================================================

                      const isSuccess =
                        response?.success !== false &&
                        responseStatus >= 200 &&
                        responseStatus < 300 &&
                        token;

                      // ==================================================
                      // LOGIN SUCCESS
                      // ==================================================

                      if (isSuccess) {
                        localStorage.setItem(
                          "token",
                          token
                        );

                        // USER
                        if (user) {
                          localStorage.setItem(
                            "user",
                            JSON.stringify(user)
                          );

                          localStorage.setItem(
                            "role",
                            user.role || ""
                          );
                        }

                        // PERMISSIONS
                        localStorage.setItem(
                          "permissions",
                          JSON.stringify(
                            permissions
                          )
                        );

                        // MENU COMPONENTS
                        localStorage.setItem(
                          "menuComponents",
                          JSON.stringify(
                            menuComponents
                          )
                        );

                        setStatus({
                          success:
                            "Login Successful",
                        });

                        // Redirect after small delay
                        setTimeout(() => {
                          this.props.navigate("/");
                        }, 1000);

                        // Do not call setSubmitting(false)
                        // on successful login
                        return;
                      }

                      // ==================================================
                      // BACKEND ERROR
                      // ==================================================

                      const backendError =
                        response?.error ||
                        response?.errors ||
                        data?.error ||
                        data?.errors ||
                        null;

                      if (
                        backendError &&
                        typeof backendError ===
                          "object"
                      ) {
                        Object.keys(
                          backendError
                        ).forEach((key) => {
                          setFieldError(
                            key,
                            backendError[key]
                          );
                        });
                      } else {
                        setFieldError(
                          "authError",
                          response?.message ||
                            data?.message ||
                            "Login failed. Please try again."
                        );
                      }

                      this.setState({
                        loading: false,
                      });

                      setSubmitting(false);
                    } catch (error) {
                      // ==================================================
                      // CATCH ERROR
                      // ==================================================

                      this.setState({
                        loading: false,
                      });

                      const responseData =
                        error?.response?.data ||
                        {};

                      const isNetworkError =
                        error?.code ===
                          "ERR_NETWORK" ||
                        !error?.response?.status;

                      const backendError =
                        responseData?.error ||
                        responseData?.errors ||
                        null;

                      if (
                        backendError &&
                        typeof backendError ===
                          "object"
                      ) {
                        Object.keys(
                          backendError
                        ).forEach((key) => {
                          setFieldError(
                            key,
                            backendError[key]
                          );
                        });
                      } else {
                        setFieldError(
                          "authError",
                          responseData?.message ||
                            (isNetworkError
                              ? "Unable to reach the login service. Please check API access for this site."
                              : "Login failed. Please try again.")
                        );
                      }

                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    touched,
                    errors,
                    isSubmitting,
                    status,
                  }) => (
                    <Form>

                      {/* AUTH MESSAGE */}
                      {(errors.authError ||
                        status?.success) && (
                        <div
                          className={`alert ${
                            status?.success
                              ? "alert-success"
                              : "alert-danger"
                          }`}
                        >
                          {status?.success ||
                            errors.authError}
                        </div>
                      )}

                      {/* EMAIL */}
                      <div className="form-group">
                        <Field
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          className={`form-control ${
                            touched.email &&
                            errors.email
                              ? "is-invalid"
                              : ""
                          }`}
                        />

                        <ErrorMessage
                          name="email"
                          component="small"
                          className="error"
                        />
                      </div>

                      {/* PASSWORD */}
                      <div className="form-group">
                        <Field
                          type="password"
                          name="password"
                          placeholder="Password"
                          className={`form-control ${
                            touched.password &&
                            errors.password
                              ? "is-invalid"
                              : ""
                          }`}
                        />

                        <ErrorMessage
                          name="password"
                          component="small"
                          className="error"
                        />
                      </div>

                      {/* SUBMIT */}
                      <div className="form-footer">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={
                            isSubmitting
                          }
                        >
                          Login
                        </button>
                      </div>

                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

// ============================================================
// RECAPTCHA WRAPPER
// ============================================================

// function LoginWithRecaptcha(props) {
//   const { executeRecaptcha } = useGoogleReCaptcha();

//   return (
//     <Login
//       {...props}
//       executeRecaptcha={executeRecaptcha}
//     />
//   );
// }

// function LoginWrapper(props) {
//   return (
//     <GoogleReCaptchaProvider
//       reCaptchaKey={
//         process.env.REACT_APP_RECAPTCHA_SITE_KEY
//       }
//     >
//       <LoginWithRecaptcha {...props} />
//     </GoogleReCaptchaProvider>
//   );
// }

// export default withRouter(LoginWrapper);

export default withRouter(Login);
